import { FC, useCallback } from 'react'
import { ParaphraseFeedback } from '@chegg-wt/core-wa/types'
import { useDispatch, useSelector } from 'react-redux'
import {
  activeFeedbackCardIdSelector,
  sentenceOffsetsSelector,
} from '@chegg-wt/core-wa/state/selectors'
import {
  removePreviousHighlight,
  scrollMarkContentInEditor,
} from '@chegg-wt/core-wa/utils/helpers'
import { setActiveFeedbackCardId } from '@chegg-wt/core-wa/state/actions'
import { useHighlightActiveCard } from '@chegg-wt/core-wa/hooks/useHighlightActiveCard'
import { setNextCardActiveAfterDeleteOrUpdate } from '../utils'
import { handleFeedbackCardDeleteClick } from '../functions'
import { ClarityCardsContainer, ClaritySectionWrapper } from './styled'
import ClarityCard from './ClarityCard/ClarityCard'

type ClaritySectionProps = {
  paraphraseFeedbacks: ParaphraseFeedback[]
}

const ClaritySection: FC<ClaritySectionProps> = ({ paraphraseFeedbacks }) => {
  const dispatch = useDispatch()
  const sentenceOffsets = useSelector(sentenceOffsetsSelector)
  const activeCardId = useSelector(activeFeedbackCardIdSelector)
  const setActiveCard = useCallback(
    (cardId: string) => dispatch(setActiveFeedbackCardId(cardId)),
    [dispatch]
  )
  useHighlightActiveCard({
    activeCardId,
    feedbacks: paraphraseFeedbacks,
    sentenceOffsets,
    setActiveCard,
  })

  const handleCardClick = (feedbackId: string | null) => {
    if (activeCardId === feedbackId) {
      // Do nothing if current card and previous card are same
      return
    }
    removePreviousHighlight(paraphraseFeedbacks, activeCardId, sentenceOffsets)

    setActiveCard(feedbackId)
    scrollMarkContentInEditor(feedbackId)
  }

  return (
    <ClaritySectionWrapper>
      {paraphraseFeedbacks.length > 0 && (
        <ClarityCardsContainer>
          {paraphraseFeedbacks.map((paraphraseFeedback, index) => (
            <ClarityCard
              feedback={paraphraseFeedback}
              key={paraphraseFeedback.id}
              isExpanded={activeCardId === paraphraseFeedback.id}
              handleCardToggle={() => handleCardClick(paraphraseFeedback.id)}
              handleDeleteClick={(isFlagged?: boolean) =>
                handleFeedbackCardDeleteClick(
                  paraphraseFeedback.id,
                  index,
                  paraphraseFeedbacks,
                  sentenceOffsets,
                  dispatch,
                  setActiveCard,
                  isFlagged
                )
              }
              setFocus={() => {
                setNextCardActiveAfterDeleteOrUpdate(
                  index,
                  paraphraseFeedbacks,
                  setActiveCard
                )
              }}
            />
          ))}
        </ClarityCardsContainer>
      )}
    </ClaritySectionWrapper>
  )
}
export default ClaritySection
